import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateLottery',
  standalone: true
})
export class DateLotteryPipe implements PipeTransform {

  transform(value: any): unknown {
    const today = new Date().getTime();

    const startDate = new Date(value[0]).getTime();
    const endtDate = new Date(value[1]).getTime();
    // const startDate = new Date(value[0]);
    // const endtDate = new Date(value[1]);
    
    


    if (today > startDate && today < endtDate) {
      
      return true;
    }
    
    return false;
  }

}
